<template>
  <div class="button-section-container">
    <div class="button-section">
      <SsoButton
        v-if="
          !showContent &&
          emailSignUp &&
          !isActivationLink &&
          !isPasswordResetLink &&
          !isReferralLink
        "
        buttonText="Sign up with Email"
        imageUrl="email_icon.svg"
        @ssoButtonClicked="handleEmailSignUp"
      ></SsoButton>
    </div>

    <div class="content-section">
      <ValidationObserver ref="signupobserver">
        <v-form @submit.prevent="submit()">
          <div v-show="showContentForm">
            <!-- Email section -->
            <ValidationProvider
              v-if="
                whitelabel.authentication.signUp.showEmail &&
                !isActivationLink &&
                !isPasswordResetLink
              "
              id="email"
              v-slot="{ errors }"
              name="email"
              rules="required|email"
            >
              <TextField
                :disabled="
                  verifyUserLinkCode !== {} &&
                  verifyUserLinkCode !== null &&
                  verifyUserLinkCode.email !== null &&
                  verifyUserLinkCode.email !== undefined &&
                  verifyUserLinkCode.email !== '' &&
                  verifyUserLinkCode.email?.trim() !== ''
                "
                v-model.trim="email"
                :label="'Email'"
                :name="'email'"
                :errors="errors"
              />
            </ValidationProvider>
            <div
              class="email-display"
              v-if="
                whitelabel.authentication.signUp.showEmail &&
                (isActivationLink || isPasswordResetLink)
              "
            >
              <p class="mb-6">
                Email: <span>{{ verifyUserLinkCode.email }}</span>
              </p>
            </div>

            <!-- Unique identifier section -->
            <ValidationProvider
              v-if="
                whitelabel.authentication.signUp.showUniqueIdentifier &&
                !isActivationLink &&
                !isPasswordResetLink
              "
              id="unique_identifier"
              v-slot="{ errors }"
              name="uniqueIdentifier"
              rules="required"
            >
              <TextField
                v-model.trim="uniqueIdentifier"
                :label="'Industry Number*'"
                :errors="errors"
                :name="'uniqueIdentifier'"
              />
            </ValidationProvider>
            <ValidationProvider
              v-if="
                whitelabel.authentication.signUp.showPhone &&
                !isActivationLink &&
                !isPasswordResetLink
              "
              id="phone_number"
              v-slot="{ errors }"
              name="phone number"
              rules="required|cell_number"
            >
              <TextField
                v-model.trim="phone"
                :label="'Cell Number*'"
                :errors="errors"
                :name="'phone'"
              />
            </ValidationProvider>
            <ValidationProvider
              id="password"
              v-slot="{ errors }"
              name="password"
              rules="required|password"
            >
              <TextField
                v-model="password"
                :label="'Password'"
                :type="'password'"
                :errors="errors"
                :name="'password'"
              />
            </ValidationProvider>

            <ValidationProvider
              id="confirm password"
              v-slot="{ errors }"
              name="confirm password"
              rules="required|confirmed:password"
            >
              <TextField
                v-model="confirmPassword"
                :label="'Confirm Password'"
                :type="'password'"
                :errors="errors"
                :name="'confirmPassword'"
              />
            </ValidationProvider>
          </div>
        </v-form>
      </ValidationObserver>
      <div class="signup-btn-container">
        <ValidationObserver
          ref="signupobserverterms"
          v-show="interactedWith === 'email'"
        >
          <ValidationProvider
            id="accepted_terms"
            v-slot="{ errors }"
            name="accepted_terms"
            :rules="isPasswordResetLink ? {} : { is: [true] }"
          >
            <v-checkbox
              v-if="!isPasswordResetLink"
              v-model="acceptedTerms"
              color="primary"
              :error-messages="errors"
            >
              <template #label>
                <div class="terms-and-conditions-container">
                  By signing up, I accept
                  <a
                    v-if="['oldmutual', 'teba'].includes(whitelabel.brand)"
                    :href="$router.resolve({ name: 'TermsAndConditions' }).href"
                    target="_blank"
                    @click.stop
                  >
                    {{ whitelabel.name }}'s terms & conditions
                  </a>
                  <a
                    v-if="whitelabel.brand == 'quickwill'"
                    target="_blank"
                    :href="whitelabel.termsAndConditionsLocation"
                    @click.stop
                    >{{ whitelabel.name }}'s terms & conditions</a
                  >
                </div>
              </template>
            </v-checkbox>
          </ValidationProvider>
        </ValidationObserver>

        <GradientButton
          class="grad-btn"
          type="button"
          :stretch="true"
          @gradientButtonClicked="submit()"
          :title="isPasswordResetLink ? 'Save' : 'Sign Up For Free'"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import SsoButton from '../guest/SsoButton.vue';
  import {
    REGISTER_MUTATION,
    SET_PASSWORD_AND_LOGIN_MUTATION,
  } from '../../constants/graphql/authentication';
  import { RESET_PASSWORD_MUTATION } from '../../constants/graphql/users';
  import * as Sentry from '@sentry/browser';
  import loginService from '../../services/LoginService';

  export default {
    name: 'SignUpWith',
    props: {
      showContent: {
        required: false,
        default: false,
      },
      isActivationLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      verifyUserLinkCode: {
        required: false,
        default: null,
        type: Object,
      },
      isPasswordResetLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isReferralLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      interactedWith: {
        required: true,
        default: '',
        type: String,
      },
    },
    components: {
      SsoButton,
    },
    methods: {
      emailSignupFocused() {
        this.$emit('signupMethodFocused', 'email');
      },
      loginClicked() {
        this.$emit('loginClicked');
      },
      submit() {
        this.$emit('signupMethodFocused', 'email');

        this.$refs.signupobserverterms.validate().then(valid => {
          if (valid) {
            this.$refs.signupobserver.validate().then(valid => {
              if (valid) {
                this.buttonLoading = true;
                if (this.isActivationLink) {
                  this.setPasswordAndLogin();
                } else if (this.isPasswordResetLink) {
                  this.resetPassword();
                } else {
                  this.register();
                }
              } else {
                const errors = this.$refs.signupobserver.ctx.errors;
                // document
                //   .getElementById(
                //     Object.keys(errors).find((field) => errors[field].length)
                //   )
                //   .scrollIntoView({ block: "center", behavior: "smooth" });
              }
            });
          } else {
            const errors = this.$refs.signupobserver.ctx.errors;
            // document
            //   .getElementById(
            //     Object.keys(errors).find((field) => errors[field].length)
            //   )
            //   .scrollIntoView({ block: "center", behavior: "smooth" });
          }
        });
      },
      register() {
        const email = this.email;
        const phone = this.phone;
        const uniqueIdentifier = this.uniqueIdentifier;
        const password = this.password;
        const acceptedTerms = this.acceptedTerms;
        const referralCode =
          this.$cookies.get('referralCode') || this.$route.params.id;
        const willCountry = this.showWillCountries ? this.willCountry : 'ZA';
        const acceptedCompetitionTerms = false;
        const testatorCompetitionReferralId = null;

        const omtId = this.$store.getters.omtId;
        const adReferrer = this.$store.getters.adReferrer;
        const fullReferrer = this.$store.getters.fullReferrer;

        this.$apollo
          .mutate({
            mutation: REGISTER_MUTATION,
            variables: {
              email,
              phone,
              uniqueIdentifier,
              password,
              acceptedTerms,
              referralCode,
              willCountry,
              acceptedCompetitionTerms,
              testatorCompetitionReferralId,
              omtId,
              adReferrer,
              fullReferrer,
              signupMethod: 'Default',
              ssoToken: null,
            },
          })
          .then(result => {
            const registerTestator = result.data.registerTestator;
            const accessToken = registerTestator.accessToken;
            const refreshToken = registerTestator.refreshToken;
            const testatorId = registerTestator.testatorId;
            const userId = registerTestator.userId;
            const willCountry = registerTestator.willCountry;
            const testatorEmail = registerTestator.email;
            dataLayer.push({
              event: 'signedupwithemail',
              omuserid: testatorId,
              emailaddress: testatorEmail,
            });

            this.$cookies.remove('referralCode');

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
            });
            this.setSentryUser(userId);
            this.redirectToNext();
          })
          .catch(error => {
            this.$emit('onError', error);
          });
      },
      resetPassword() {
        const resetPasswordCode = this.$route.params.id;
        const password = this.password;
        const acceptedTerms = false;
        this.$apollo
          .mutate({
            mutation: RESET_PASSWORD_MUTATION,
            variables: {
              resetPasswordCode,
              password,
              acceptedTerms,
            },
          })
          .then(result => {
            this.login(this.uniqueIdentifier, password);
          })
          .catch(error => {
            this.handleMutationError(error);
          });
      },
      login(unique_identifier, password) {
        loginService
          .login(unique_identifier, password, this.$apollo, this.$store)
          .then(result => {
            const login = result.data.login;
            const accessToken = login.accessToken;
            const refreshToken = login.refreshToken;
            const testatorId = login.testatorId;
            const userId = login.userId;
            const willCountry = login.willCountry;

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
            });
            loginService.setSentryUser(userId);
            loginService.redirectToNext(this.$router);
          })
          .catch(error => {
            this.buttonLoading = false;
            if (error.message.includes('GraphQL error:')) {
              this.errorMessage = error.message
                .replace('GraphQL error:', '')
                .trim();
            } else {
              this.errorMessage =
                "Something went wrong, we're looking into it. Please try login again.";
              throw error;
            }
          });
      },
      setPasswordAndLogin() {
        const userLinkCode = this.$route.params.id;
        const password = this.password;
        const acceptedTerms = this.acceptedTerms;

        this.$apollo
          .mutate({
            mutation: SET_PASSWORD_AND_LOGIN_MUTATION,
            variables: {
              userLinkCode,
              password,
              acceptedTerms,
            },
          })
          .then(result => {
            const setPasswordAndLogin = result.data.setPasswordAndLogin;
            const accessToken = setPasswordAndLogin.accessToken;
            const refreshToken = setPasswordAndLogin.refreshToken;
            const testatorId = setPasswordAndLogin.testatorId;
            const userId = setPasswordAndLogin.userId;
            const willCountry = setPasswordAndLogin.willCountry;

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
            });
            this.setSentryUser(userId);
            this.redirectToNext();
          })
          .catch(error => {
            this.handleMutationError(error);
          });
      },
      setSentryUser(userId) {
        Sentry.setUser({ id: userId });
      },
      redirectToNext() {
        this.$router.push('/overview');
        this.buttonLoading = false;
      },
      handleEmailSignUp() {
        this.showContentForm = !this.showContentForm;
        dataLayer.push({
          event: 'loginwithemailbtn',
          omuserid: 'systemuserid',
        });
      },
    },
    data(props) {
      return {
        showContentForm:
          props.isActivationLink ||
          props.isPasswordResetLink ||
          props.isReferralLink ||
          props.showContent,
        email: props.verifyUserLinkCode?.email || '',
        uniqueIdentifier: '',
        phone: '',
        password: '',
        confirmPassword: '',
        willCountry: 'ZA',
        acceptedTerms: false,
        errorMessage: '',
        showPassword: false,
        showConfirmPassword: false,
        buttonLoading: false,
        defaultSACountrySpecified: props.defaultSACountry,
        home: {},
      };
    },
    created() {
      if (!this.emailSignUp) {
        this.showContentForm = true;
      }
    },
    computed: {
      emailSignUp() {
        return this.whitelabel.authentication.login.fieldName === 'email';
      },
    },
    watch: {
      showContent() {
        this.showContentForm = false;
      },
      isActivationLink(newValue) {
        this.showContentForm = newValue;
      },
      isPasswordResetLink(newValue) {
        this.showContentForm = newValue;
      },
      isReferralLink(newValue) {
        this.showContentForm = newValue;
      },
      verifyUserLinkCode(newValue) {
        this.uniqueIdentifier = !!newValue.uniqueIdentifier
          ? newValue.uniqueIdentifier
          : newValue.email;
        this.email = newValue.email;
      },
      interactedWith(newValue, oldValue) {
        if (oldValue === 'email') {
          this.$refs.signupobserver.reset();
          this.$refs.signupobserverterms.reset();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .button-section-container {
    width: 100%;

    .grad-btn {
      margin-top: 16px;
    }

    .email-display {
      p {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        margin: 0;
        text-align: left;
        span {
          text-wrap: wrap;
          word-wrap: break-word;
          word-break: break-all;
          overflow-wrap: break-word;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
        }
      }
    }
    .button-section {
      margin-bottom: 24px;
    }
    .content-section {
      width: 100%;

      .signup-btn-container {
        margin-top: 16px;

        .terms-and-conditions-container {
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
          text-align: left;
          color: #282828;
          a {
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            text-align: left;
            color: #282828;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .button-section-container {
      .content-section {
        .signup-btn-container {
          margin-top: 30px;
        }
      }
    }
  }
</style>
